import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { getLaminasApiData } from 'services/api';

interface RequestResponse {
  status: number;
  data: string;
}
type RequestCallback = (error: unknown, response: RequestResponse) => void;

// todo: provide any way get the UserSettings.locale from react store, ie. by finding a way to init i18n inside react
function getUserLocale() {
  if ('userSettings' in window) {
    if ('locale' in window.userSettings) {
      return window.userSettings.locale;
    }
  }
  return 'en_US'; // fallback locale for accessing react application directly
}

const locale = getUserLocale();

const getTranslations = (locale: string, ns: string) => {
  return getLaminasApiData<string>(`/i18n/phrase/translation/list/${locale}/${ns}`);
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: locale,
    // debug: true,
    ns: ['partner', 'overview', 'validation', 'imports'],
    defaultNS: 'common',
    supportedLngs: [locale],
    load: 'currentOnly',
    backend: {
      loadPath: '{{lng}}|{{ns}}',

      request: (options: unknown, url: string, payload: unknown, callback: RequestCallback) => {
        const [lng, ns] = url.split('|');
        getTranslations(lng, ns)
          .then((response) => {
            callback(null, {
              data: response.data,
              status: 200,
            });
          }).catch((e) => {
            // eslint-disable-next-line no-console
            console.error(e);
            callback(null, {
              data: '',
              status: 500,
            });
          });
      },
    },
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    partialBundledLanguages: true,
    react: {
      useSuspense: true,
    },
    maxRetries: 0,
  });

export default i18n;
